export const Breakpoint_Laptop = '1560px';
export const Breakpoint_Ultrabook = '1380px';
export const Breakpoint_Tablet = '1050px';
export const Breakpoint_Phone = '980px';
